import { useContext, useEffect } from "react";
import { useMapEvents } from "react-leaflet";
import UiContext from "../../context/UiContext";
import Icon from "../Icon";

import styles from "./MapListener.module.css";
import AuthContext from "../../context/AuthContext";

function MapListener() {
  const { openDialog, setLocation, setMapElement } = useContext(UiContext);
  const { setUserLocation } = useContext(AuthContext);

  const map = useMapEvents({
    locationfound: (location) => {
      map.flyTo(location.latlng, map.getZoom());
      setUserLocation(location.latlng);
    },
    moveend: () => {
      const mapCenter = map.getCenter();
      setLocation(mapCenter);
    },
  });

  useEffect(() => {
    if (map) {
      setMapElement(map);
    }
  }, [map]);

  return (
    <>
      <button className={styles.location} onClick={() => map.locate()}>
        <Icon type="location" size="small" />
      </button>
      <button
        className={styles.info}
        onClick={() => openDialog({ name: "info" })}
      >
        <Icon type="info" size="small" />
      </button>
    </>
  );
}

export default MapListener;
